const animation = require("./Speech Bubble_Monster.json");

module.exports = {
    loop: false,
    autoplay: true,
    prerender: true,
    renderer: "svg",
    animationData: animation,
    rendererSettings: {
        preserveAspectRatio: 'xMidyMid'
    },
}